var map = {
	"./1/更多.png": "Bwws",
	"./2/更多.png": "JUY1",
	"./3/更多.png": "4wbT",
	"./4/更多.png": "33Fd",
	"./5/更多.png": "3K7r",
	"./6/更多.png": "49Fp",
	"./7/更多.png": "frnj",
	"./8/更多.png": "CIsR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+gt2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/更多\.png$
// module id = +gt2
// module chunks = 1